<template>
    <v-list nav dense>
        <v-list-item :class="{ 'ml-2 drawer-active-item': !collapsed }" active-class="primary--text" :to="backNavigationRoute">
            <v-list-item-icon>
                <v-tooltip right :disabled="!collapsed">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-arrow-left</v-icon>
                    </template>
                    <span>Back</span>
                </v-tooltip>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>Back</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DrawerConfigBackSection',
    props: {
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(['userOrgs', 'currentOrgData']),
        ...mapState('orgStore', ['spacesWithPrimarySnapshots']),
        ...mapState('spaceStore', ['spaceInstances']),
        currentOrgOid() {
            return this.$route.params.oid || this.currentOrgData?.oid || this.userOrgs[0]?.oid
        },
        backNavigationRoute() {
            const routeName = this.$route.name || ''
            const oid = this.currentOrgOid
            const sid = this.$route.params.sid

            if (routeName.startsWith('config-pool')) {
                const rpid = Number(this.$route.params.rpid)
                if (Number.isFinite(rpid) && rpid > 0) {
                    return {
                        name: 'reporting-rp-overview',
                        params: { rpid }
                    }
                }

                return {
                    name: 'user-resources'
                }
            }

            if (sid) {
                const selectedSpace = this.spacesWithPrimarySnapshots.find(space => space.sid.toString() === sid.toString())
                const iid = this.$route.params.iid || selectedSpace?.iid
                const selectedInstance = iid ? this.spaceInstances.find(instance => instance.iid.toString() === iid.toString()) : null
                const snid = this.$route.params.snid || selectedInstance?.dev_snid || selectedSpace?.snid

                if (oid && iid && snid) {
                    return {
                        name: 'snapshot-overview',
                        params: { oid, sid, iid, snid }
                    }
                }

                if (oid) {
                    return {
                        name: 'home-spaces',
                        params: { oid }
                    }
                }
            }

            return {
                name: 'home-dashboard',
                params: { oid }
            }
        }
    }
}
</script>
